import { ENDPOINTS_EMPLOYEE } from 'common/endpoints/food-benefit.endpoints';
import employeeAssembler from './employeeRepository.assemblers';

class employeeRepositoryService {
  constructor($http, $window) {
    'ngInject';
    this.http = $http;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  getEmployee(employeeId) {
    return this.http.get(ENDPOINTS_EMPLOYEE.get.initial(employeeId)).then(response => {
      const employeeData = response.data;
      return employeeAssembler.assemble(employeeId, employeeData);
    });
  }

}

export default employeeRepositoryService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/employeeRepository/employeeRepository.service.js